"use client";

import React, { forwardRef } from "react";
import { createPolymorphicComponent, Text } from "@mantine/core";
import IHVTextProps from "./IHVTextProps";
import style from "./HVText.module.css";

const HVText = createPolymorphicComponent<"p", IHVTextProps>(
  forwardRef<HTMLParagraphElement, IHVTextProps>(
    ({ type, weight, children, ...rest }: IHVTextProps, ref) => (
      <Text
        component="p"
        ref={ref}
        style={{
          fontWeight: `var(--hv-font-weight-${weight?.toLowerCase() || "regular"})`,
        }}
        {...rest}
        className={`${style.root} ${style[`${type?.toLowerCase()}`] || style["body-md"]} ${rest?.className}`}
      >
        {children}
      </Text>
    ),
  ),
);

export default HVText;
